import { render, staticRenderFns } from "./HeroNew.vue?vue&type=template&id=0194f6f2&scoped=true&"
import script from "./HeroNew.vue?vue&type=script&lang=js&"
export * from "./HeroNew.vue?vue&type=script&lang=js&"
import style0 from "./HeroNew.vue?vue&type=style&index=0&id=0194f6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0194f6f2",
  null
  
)

export default component.exports